import { useState, useEffect } from "react";
import WorkspaceService from "services/workspace-service";

export default function useWorkspaceSubscription(autoFetch = true) {
    const [activeSubscription, setActiveSubscription] = useState(null);
    const [pendingSubscription, setPendingSubscription] = useState(null);
    const [history, setHistory] = useState([]);

    const fetchSubs = async () => {
        try {
            const response = await WorkspaceService.fetchWorkspaceSubscription();

            if (Array.isArray(response)) {
                setHistory(response);

                // Active
                const active = response.find(s => s.status?.toLowerCase() === "active");
                if (active) {
                    setActiveSubscription({
                        code: active.code,
                        plan: active.plan,
                        billingCycle: active.billing_cycle,
                        endDate: active.end_date,
                        renewalDate: active.next_renewal_date,
                        status: active.status,
                        autoRenewal: active.auto_renew,
                        stripe_subscription_id: active.stripe_subscription_id,
                        stripe_customer_id: active.stripe_customer_id,
                        stripe_latest_invoice_id: active.stripe_latest_invoice_id,
                    });
                } else {
                    setActiveSubscription(null);
                }

                // Pending
                const pending = response.find(s => s.status?.toLowerCase() === "pending");
                setPendingSubscription(pending || null);
            }
        } catch (error) {
            console.error("Error in useWorkspaceSubscription hook:", error);
            setActiveSubscription(null);
            setPendingSubscription(null);
            setHistory([]);
        }
    };

    useEffect(() => {
        if (autoFetch) fetchSubs();
    }, []);

    return { activeSubscription, pendingSubscription, history, refresh: fetchSubs };
}
